import template from './homeLoanSwitchSubmit.template.html';
import templateSwitch from './homeLoanSwitchPostDialog.template.html';

export default {
  template,
  bindings: {
    idTicket: '<',
    onFinish: '&'
  },
controller: class controller {
    constructor(
      $mdDialog,
      $rootScope,
      $stateParams,
      $state,
      $q,
      dateTimeService,
      uiService,
      homeLoanService,
      jobService,
      ticketService,
      helperService
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.organizationCountry = helperService.getOrganizationCountry();
      ctrl.isSwitchSubmitting = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.switch = () => {
        function dialogController() {
          const self = this;

          self.comment = '';
          self.timeStamp = 0;
          self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
          self.label = ctrl.organizationCountry.cca2 === 'NZ' ? 'Refix' : 'Switch';
          self.idTicket = ctrl.idTicket;
          self.jobsToCreate = [];

          self.onJobStatusChange = (jobsToCreate) => {
            self.jobsToCreate = jobsToCreate;
          };

          dateTimeService.getSet(self, self, 'timeStamp', 'getSetSwitchDate');

          this.confirm = function () {
            const { comment, timeStamp, jobsToCreate } = self;
            $mdDialog.hide({ comment, timeStamp, jobsToCreate });
          };
          this.cancel = function () {
            ctrl.$mdDialog.hide(false);
          };
        }

        ctrl.$mdDialog
          .show({
            locals: {},
            template: templateSwitch,
            controllerAs: '$ctrl',
            controller: dialogController,
            clickOutsideToClose: false
          })
          .then((res) => {
            if (!res) {
              return;
            }

            ctrl.isSwitchSubmitting = true;
            homeLoanService
              .splitSwitch({ ...res, idTicket: ctrl.idTicket })
              .then(async (result) => {
                ctrl.isSwitchSubmitting = false;
                if (!result || !result.status) {
                  uiService.toast({
                    text: {
                      p1: 'There was a problem',
                      p2: 'posting',
                      p3: 'please try again later'
                    },
                    warn: true
                  });
                  return;
                }

                if (res.jobsToCreate.length) {
                  await $q.all(res.jobsToCreate.map((job) => jobService.createJob(job)));
                }

                $state.transitionTo('homeLoan', {
                  id: $stateParams.id,
                  dd: $stateParams.dd
                });
              })
              .catch((e) => {
                uiService.toast({
                  text: {
                    p1: 'There was a problem',
                    p2: 'posting',
                    p3: 'please try again later'
                  },
                  warn: true
                });
              });
          });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {};

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function () {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {};
    }
  }
};
